import { render, staticRenderFns } from "./NotificationSpecification.vue?vue&type=template&id=6560f592&scoped=true&lang=pug&"
import script from "./NotificationSpecification.vue?vue&type=script&lang=js&"
export * from "./NotificationSpecification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6560f592",
  null
  
)

export default component.exports